import Store from '@/abstract/store';

export interface SoftConfig{
  softName: string;
  copyRightValue: string;
  version: string;
  useCas: string;
}

class SoftConfigtore extends Store<SoftConfig> {
  // eslint-disable-next-line class-methods-use-this
  protected data(): SoftConfig {
    return {
      softName: '',
      copyRightValue: '',
      version: '',
      useCas: '0',
    };
  }

  updateSoftConfig(data: SoftConfig) {
    this.state.softName = data.softName;
    this.state.copyRightValue = data.copyRightValue;
    this.state.useCas = data.useCas;
  }

  updateVersion(version: string) {
    this.state.version = version;
  }
}

export default new SoftConfigtore();
